// Panel labels follow the app language. The docs and their breadcrumbs
// (including "Home") are English only.
export const T = {
  en_GB: {
    documentation: "Documentation",
    back: "Back",
    searchPlaceholder: "Search documentation...",
    noResults: "No results found for",
    pageNotFound: "Page not found",
    returnToHome: "Return to home",
    loadingDocs: "Loading documentation...",
    noContent: "No content available",
  },
  nb_NO: {
    documentation: "Dokumentasjon",
    back: "Tilbake",
    searchPlaceholder: "Søk i dokumentasjonen...",
    noResults: "Ingen resultater funnet for",
    pageNotFound: "Side ikke funnet",
    returnToHome: "Tilbake til hjem",
    loadingDocs: "Laster dokumentasjon...",
    noContent: "Ingen innhold tilgjengelig",
  },
} as const;
